export const FIRE_CONFIDENCE_LEVELS = {
  n: 'Nominal',
  l: 'Low',
  h: 'High',
} as const
